import React from "react";
import { Spin } from "antd";
import useLang from "../../../hooks/useLang";
import useSortingMachine from "../../../hooks/useSortingMachine";
import ActivePlanBanner from "./ActivePlanBanner";
import PlanManager from "./PlanManager";
import SlotMappingEditor from "./SlotMappingEditor";

const SortingMachineTab = () => {
	const { strings } = useLang("sortingMachineTab");
	const {
		plans,
		activePlan,
		selectedPlanId,
		selectedPlanDetail,
		zoneTree,
		loading,
		selectPlan,
		createPlan,
		renamePlan,
		deletePlan,
		activatePlan,
		updateSlot,
		setSlotZones,
	} = useSortingMachine();

	if (loading.plans && plans.length === 0) {
		return (
			<div className="flex justify-center items-center py-20">
				<Spin size="large" />
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-6">
			<ActivePlanBanner
				plans={plans}
				activePlan={activePlan}
				onChangeActivePlan={activatePlan}
			/>

			<div className="border-b border-gray-200 pb-4">
				<h3 className="text-base font-semibold text-gray-700 mb-3">
					{strings?.planManager?.title ?? "Sorting Plans"}
				</h3>
				<PlanManager
					plans={plans}
					selectedPlanId={selectedPlanId}
					onSelectPlan={selectPlan}
					onCreatePlan={createPlan}
					onRenamePlan={renamePlan}
					onDeletePlan={deletePlan}
				/>
			</div>

			<div>
				<h3 className="text-base font-semibold text-gray-700 mb-3">
					{strings?.slotMapping?.title ?? "Slot Mapping"}
					{selectedPlanDetail && (
						<span className="ml-2 font-normal text-sm text-gray-400">
							— {selectedPlanDetail.name}
						</span>
					)}
				</h3>
				{loading.detail && !selectedPlanDetail ? (
					<div className="flex justify-center items-center py-10">
						<Spin />
					</div>
				) : (
					<SlotMappingEditor
						plan={selectedPlanDetail}
						zoneTree={zoneTree}
						onSlotFieldsChange={updateSlot}
						onZoneMappingSave={setSlotZones}
					/>
				)}
			</div>
		</div>
	);
};

export default SortingMachineTab;
